import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { obtenerCotizacionesPorFacturarVencidas } from "../services/cotizacionService";

const fmtMX = (n) =>
  (Number(n) || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Aviso que aparece una sola vez por inicio de sesión (lo arma Login.js dejando una
// bandera en sessionStorage) listando las cotizaciones "por facturar" cuya fecha ya llegó.
export default function AvisoPorFacturarModal() {
  const navigate = useNavigate();
  const [cotizaciones, setCotizaciones] = useState(null); // null = aún no se sabe

  useEffect(() => {
    if (sessionStorage.getItem("avisoPorFacturarPendiente") !== "1") return;
    sessionStorage.removeItem("avisoPorFacturarPendiente");

    obtenerCotizacionesPorFacturarVencidas()
      .then(({ data }) => {
        const lista = Array.isArray(data) ? data : [];
        if (lista.length) setCotizaciones(lista);
      })
      .catch(() => {}); // silencioso — no es crítico interrumpir el login por esto
  }, []);

  if (!cotizaciones) return null;

  const irACotizacion = (id) => {
    setCotizaciones(null);
    navigate(`/cotizaciones/${id}/editar`);
  };

  return (
    <div className="lmd-modal-overlay" onClick={() => setCotizaciones(null)}>
      <div className="lmd-modal lmd-modal-md" onClick={(e) => e.stopPropagation()}>
        <div className="lmd-modal-header">
          <h3 className="lmd-modal-title">Cotizaciones por facturar</h3>
          <button className="lmd-modal-close" onClick={() => setCotizaciones(null)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
          </button>
        </div>
        <div className="lmd-modal-body">
          <p style={{ margin: "0 0 12px", fontSize: "var(--fs-sm)", color: "var(--clr-text-secondary)" }}>
            Ya llegó la fecha que marcaste para facturar estas {cotizaciones.length === 1 ? "cotización" : "cotizaciones"}:
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 360, overflowY: "auto" }}>
            {cotizaciones.map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => irACotizacion(c.id)}
                style={{
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  padding: 10, border: "1px solid var(--clr-border)", borderRadius: "var(--radius-sm)",
                  background: "#fff", cursor: "pointer", textAlign: "left", width: "100%",
                }}
              >
                <div>
                  <div style={{ fontWeight: 600, fontSize: "var(--fs-sm)" }}>#{c.cotizacion} — {c.clienteNombre}</div>
                  <div style={{ fontSize: 12, color: "var(--clr-text-secondary)" }}>
                    Fecha para facturar: {c.fechaPorFacturar ? String(c.fechaPorFacturar).slice(0, 10) : "—"}
                  </div>
                </div>
                <div style={{ fontWeight: 700 }}>
                  ${fmtMX(c.total)} {c.moneda === "D" ? "USD" : "MXN"}
                </div>
              </button>
            ))}
          </div>
        </div>
        <div className="lmd-modal-footer">
          <button className="lmd-btn lmd-btn-secondary" onClick={() => setCotizaciones(null)}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
